'use strict';

/*global BasicQueue*/
/*global app*/
/*global services*/

function ReceiptCardQueue(containerId) {
  BasicQueue.call(this, containerId);

  this.init();
}

ReceiptCardQueue.prototype = $.extend({}, BasicQueue.prototype, {
  constructor: 'ReceiptCardQueue',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.$container.on('click', '.info-item--receipt', function () {
      _this.infoItem($(this));

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  infoItem: function infoItem($btn) {
    var _this = this;

    var modal = services.get('modal');

    modal.open({
      height: 'auto',
    });
    modal.block();
    app.get($btn.attr('href'), function (res) {
      modal.unBlock();

      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
